import React from "react";

export default function Titulo({ titulo }) {
  return <h2 style={{ color: "orange" }}>{titulo}</h2>;
}
